import { Autocomplete, Box, TextField, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { ColorPickerInput } from 'src/components/SCADA/colorPickerInput/ColorPickerInput';
import { fontSizesOptions } from 'src/components/SCADA/config/elementsOptions';
import { useCustomDashboardContext } from 'src/contexts/customDashboardContext/customDashboard.context';
import { TextLabelValuesTypes } from './types';

export const TextLabelDrawerContent = () => {
  const { selectedNode, updateNodeData, nodes } = useCustomDashboardContext();
  const theme = useTheme();
  const greyColor = theme.palette.grey[300];
  const blackColor = theme.palette.common.black;

  const [values, setFormValues] = useState<TextLabelValuesTypes>({
    text: 'Label',
    textSize: '11px',
    color: blackColor,
    backgroundColor: greyColor,
  });

  const onChangeHandler = (name: string, value: string | boolean | null) => {
    setFormValues((prevState) => {
      const updated = { ...prevState, [name]: value };

      if (selectedNode?.id) {
        updateNodeData(selectedNode.id, updated);
      }

      return updated;
    });
  };

  useEffect(() => {
    if (!selectedNode?.id) return;

    const findNode = nodes.find((node) => node.id === selectedNode?.id);
    const text = (findNode?.data as TextLabelValuesTypes)?.text ?? 'Label';
    const textSize = (findNode?.data as TextLabelValuesTypes)?.textSize ?? '11px';
    const color = (findNode?.data as TextLabelValuesTypes)?.color ?? blackColor;
    const backgroundColor = (findNode?.data as TextLabelValuesTypes)?.backgroundColor ?? greyColor;
    setFormValues({ text, textSize, color, backgroundColor });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNode?.id, nodes]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <TextField
        size="small"
        value={values.text}
        label="Text"
        name="text"
        onChange={(e) => onChangeHandler('text', e.target.value)}
      />
      <Autocomplete
        size="small"
        value={values.textSize}
        inputValue={values.textSize}
        onChange={(_, selectedTextSize) => {
          onChangeHandler('textSize', selectedTextSize ?? '');
        }}
        onInputChange={(_, newInputValue) => {
          onChangeHandler('textSize', newInputValue);
        }}
        options={fontSizesOptions}
        renderInput={(params) => (
          <TextField {...params} label="Text Size" data-sm="text-size-input" />
        )}
      />

      <ColorPickerInput
        color={values.color}
        onChangeHandler={onChangeHandler}
        name="color"
        label="Text Color"
      />
      <ColorPickerInput
        color={values.backgroundColor}
        onChangeHandler={onChangeHandler}
        name="backgroundColor"
        label="Background Color"
      />
    </Box>
  );
};
